module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/activity-978400ac35392be212dbf6f2f73ebca4.webp";